// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-accordion_default__e1ifs"};